import CitySEOHead from "@/components/feature/CitySEOHead";
import NashvilleHeroSection from "./components/HeroSection";
import NashvilleStickyNav from "./components/StickyNav";
import NashvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import NashvilleFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { nashvilleConfig } from "./data";

export default function NashvillePage() {
  const c = nashvilleConfig;

  return (
    <>
      <CitySEOHead
        city={c.city}
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/nashville"
        title="Emergency Passport Nashville, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Nashville, TN — as fast as 24 hours. Direct access to the Atlanta Passport Agency. A+ BBB rated, registered State Dept. courier serving Music Row, Vanderbilt Medical, and all Middle Tennessee."
        geoPlacename="Nashville, Tennessee"
        geoPosition="36.1627;-86.7816"
        faqs={faqs}
        servicesSchema={c.servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <div className="font-sans">
      <NashvilleHeroSection />
      <NashvilleStickyNav />
      <NashvilleProcessingTimeSection />
      <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
      <CityLocalAreaSection
        city={c.city}
        state={c.state}
        cities={c.nearbyCitiesZips}
        benefits={c.benefits}
        internalLinks={c.internalLinks}
        officeNote={c.fpcOfficeNote}
        officeDistance={c.fpcOfficeDistance}
        officeAddress={c.fpcOfficeAddress}
        serviceAreaIntro={c.serviceAreaIntro}
        nearbyCitiesIntro={c.nearbyCitiesIntro}
      />
      {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
      {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
      <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
      <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
      <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
      <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
      <NashvilleFAQSection />
      <CityHelpfulResourcesSection
        city={c.city}
        state={c.state}
        photoLocations={c.photoLocations}
        dmvLocations={c.dmvLocations}
        airports={c.airports}
        dmvWebsite={c.dmvWebsite}
        dmvLabel={c.dmvLabel}
        vitalRecordsLinks={c.vitalRecordsLinks}
      />
      <SEOCrossLinks currentRoute="/cities/nashville" state="TN" />
      <CityFinalCTA />
    </div>
    </>
  );
}